<template>
  <span>
    <v-dialog max-width="80%" v-model="computed_dialog">
      <app-card>
        <h4>TẠO PHIẾU CHUYỂN TIỀN NGÂN HÀNG NỘI BỘ</h4>
        <v-form ref="form">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 md3>
                <v-text-field
                  label="Mã chứng từ"
                  :disabled="true"
                  v-model="form.receipt_id"
                  prepend-icon="account_box"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-select
                  label="Hình thức đối ứng"
                  :disabled="false"
                  v-model="form.wallet_account_name"
                  :items="correspondence_bank_account_list"
                  prepend-icon="account_balance_wallet"
                  :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  label="Số tiền chi"
                  :disabled="true"
                  v-model="form.amount"
                  prepend-icon="money"
                  v-currency
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  slot="activator"
                  label="Ngày tạo phiếu"
                  v-model="form.date_created"
                  :disabled="true"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md9>
                <v-text-field
                  label="Diễn giải"
                  v-model="form.description"
                  prepend-icon="event_note"
                  :disabled="loading.submit"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-btn
                  :loading="loading.getPossibleLinkTransactions"
                  :disabled="
                    !form.wallet_account_name ||
                      loading.getPossibleLinkTransactions ||
                      alert.show
                  "
                  @click="getPossibleLinkTransactions"
                  color="green"
                  class="white--text"
                >
                  Tìm giao dịch liên kết
                </v-btn>
              </v-flex>
              <v-flex
                xs12
                v-if="
                  listPossibleLinkTransaction &&
                    listPossibleLinkTransaction.length
                "
              >
                <v-data-table
                  disable-initial-sort
                  :headers="headers"
                  :items="listPossibleLinkTransaction"
                  item-key="id"
                  :rows-per-page-items="listPossibleLinkTransaction.length"
                >
                  <template #items="props">
                    <tr>
                      <td class="text-center">
                        <input
                          type="radio"
                          :value="props.item"
                          v-model="linkTransaction"
                        />
                      </td>
                      <td class="text-center">
                        {{ props.item.date_created | formatTimeServer }}
                      </td>
                      <td class="text-right">
                        {{ Math.abs(props.item.amount) | formatCurrency }}
                      </td>
                      <td class="text-right">
                        {{ props.item.balance | formatCurrency }}
                      </td>
                      <td class="text-left">
                        {{ props.item.description }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12 v-if="alert.show">
                <v-alert :value="alert.show" :type="alert.type" outline>
                  {{ alert.text }}
                </v-alert>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :loading="loading.submit"
              :disabled="!linkTransaction || loading.submit || alert.show"
              @click="submit"
              color="green"
              class="white--text"
            >
              Tạo Phiếu
            </v-btn>
          </v-card-actions>
        </v-form>
      </app-card>
    </v-dialog>
  </span>
</template>

<script>
import api from "Api";
import {
  BANK_ACCOUNT_TYPE_LIST,
  WALLET_ID_AND_ACCOUNT_TYPE_MAP,
} from "Constants/db-config";
import { formatTimeServer, buildParamQuery } from "Helpers";

export default {
  name: "dialog-tao-phieu-chuyen-tien-ngan-hang-noi-bo",
  props: {
    dialog: Boolean,
    transaction: Object,
  },
  data() {
    return {
      headers: [
        { text: "Thao tác", align: "center", sortable: false },
        {
          text: "Ngày",
          align: "center",
          sortable: true,
          value: "date_action",
        },
        {
          text: "Số dư",
          align: "center",
          sortable: true,
          value: "balance",
        },
        {
          text: "Số dư cộng dồn",
          align: "center",
          sortable: true,
          value: "accumulated_balance",
        },
        {
          text: "Nội dung chi tiết",
          align: "center",
          sortable: true,
          value: "description",
        },
      ],
      computed_dialog: this.dialog,
      loading: {
        submit: false,
      },
      rules: {
        required: (value) => !!value || "Vui lòng điền thông tin này.",
      },
      alert: {
        show: false,
        text: "",
        type: "error",
      },
      correspondence_bank_account_list: [],
      form: null,
      listPossibleLinkTransaction: null,
      linkTransaction: null,
    };
  },
  computed: {},
  watch: {
    computed_dialog(nv) {
      this.$emit("changeDialogState", nv);
      if (!nv) this.clearInput();
    },
    dialog(nv) {
      this.computed_dialog = nv;
    },
    "form.wallet_account_name"(nv, ov) {
      if (nv !== ov) {
        this.listPossibleLinkTransaction = null;
        this.linkTransaction = null;
      }
    },
    linkTransaction(nv) {

      if (this.transaction.amount >= 0) {
        if (!nv) {
          this.form.receipt_id = "";
        } else {
          this.form.receipt_id = `${nv.bank_receipt_id}.1`
        }
      }
    },
    transaction: {
      immediate: true,
      handler(newTransaction) {
        const wallet_account =
          WALLET_ID_AND_ACCOUNT_TYPE_MAP[newTransaction.wallet_account_id];
        this.correspondence_bank_account_list = wallet_account
          ? BANK_ACCOUNT_TYPE_LIST.filter(
              (bank_account) => wallet_account !== bank_account
            )
          : BANK_ACCOUNT_TYPE_LIST;

        this.form = {
          receipt_id: newTransaction.amount >= 0 ? "" : `${newTransaction.bank_receipt_id}.1`,
          date_created: formatTimeServer(newTransaction.date_created),
          amount: newTransaction.amount,
          description: "",
          wallet_account_name: undefined,
        };
      },
    },
  },
  methods: {
    clearInput: function() {
      this.$refs.form.reset();
    },
    getPossibleLinkTransactions: async function() {
      this.loading.getPossibleLinkTransactions = true;
      this.listPossibleLinkTransaction = null;
      this.linkTransaction = null;

      const correspondenceWalletAccountId = Number(
        Object.entries(WALLET_ID_AND_ACCOUNT_TYPE_MAP).find(
          ([_, name]) => name === this.form.wallet_account_name
        )[0]
      );
      const params = {
        date: formatTimeServer(this.transaction.date_created, "MM-DD-YYYY"),
        correspondenceWalletAccountId,
        amount: -this.transaction.amount,
      };

      const query = buildParamQuery(params);

      try {
        const result =
          (await api.getPossibleLinkTransactions(query)).data || [];
        if (result.length === 0) {
          swal.fire("Không có giao dịch liên kết khả thi!");
          this.listPossibleLinkTransaction = null;
          this.loading.getPossibleLinkTransactions = false;
          return;
        }

        this.listPossibleLinkTransaction = result;
      } catch (error) {
        swal.fire("Đã xảy ra lỗi!");
      }

      this.loading.getPossibleLinkTransactions = false;
    },
    submit: async function() {
      this.loading.submit = true;

      let transfer_transaction = null;
      let receiving_transaction = null;

      if (this.transaction.amount >= 0) {
        receiving_transaction = this.transaction;
        transfer_transaction = this.linkTransaction;
      } else {
        transfer_transaction = this.transaction;
        receiving_transaction = this.linkTransaction;
      }

      const postData = {
        receipt_id: this.form.receipt_id,
        date_created: this.transaction.date_created,
        amount:
          this.transaction.amount >= 0
            ? this.transaction.amount
            : -this.transaction.amount,
        description: this.form.description,
        transfer_transaction_id: transfer_transaction._id,
        transfer_wallet_account_id: transfer_transaction.wallet_account_id,
        receiving_transaction_id: receiving_transaction._id,
        receiving_wallet_account_id: receiving_transaction.wallet_account_id,
      };

      try {
        const response = await api.createBankInternalTransfer(postData);
        this.loading.submit = false;

        if (response.status === 200) {
          this.computed_dialog = false;

          swal.fire("Tạo thành công!");
          this.clearInput();
          this.$emit("reloadTable");
        } else {
          const error = await response.json();
          swal.fire(`Đã xảy ra lỗi.
${error.message}`);
        }
      } catch (error) {
        swal.fire("Đã xảy ra lỗi.");
      }
    },
  },
};
</script>

<style></style>
